const initState = {}

const userReducer = (state = initState, action) => {
  const payload = action.payload;
  switch (action.type) {
    
    case 'UPDATE_USERS_SUCCESS':
      console.log('update users success')
      return ({...state, reduxUsers:payload})

    default:
      return state;
  }
};

export default userReducer;